import { Action, createReducer, on } from '@ngrx/store';
import { Status } from '../../../models/status';
import { initializeSabreEngineServiceState, pullVcrControl, pullVcrControlComplete } from './sabre-engine.actions';
import { initialSabreEngineServiceState } from './sabre-engine.state';

const featureReducer = createReducer(
  initialSabreEngineServiceState,

  on(initializeSabreEngineServiceState, (state) => ({
    ...state,
    ...initialSabreEngineServiceState,
  })),

  on(pullVcrControl, (state) => ({
    ...state,
    pullVcrControlStatus: Status.UPDATING,
  })),

  on(pullVcrControlComplete, (state, { isGenericError, response }) => ({
    ...state,
    pullVcrControlStatus: Status.STABLE,
    pullVcrControlGenericError: isGenericError,
    pullVcrControlResponse: response,
  }))
);

export function sabreEngineReducer(state = initialSabreEngineServiceState, action: Action) {
  return featureReducer(state, action);
}
